module.exports = __webpack_public_path__ + "c911069aedd7f10008033e3666c87c7b.svg";